var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 14.75C1.325 14.75 1.0625 14.6375 0.8375 14.4125C0.6125 14.1875 0.5 13.925 0.5 13.625V4.625C0.5 4.325 0.6125 4.0625 0.8375 3.8375C1.0625 3.6125 1.325 3.5 1.625 3.5H5V1.625C5 1.325 5.1125 1.0625 5.3375 0.8375C5.5625 0.6125 5.825 0.5 6.125 0.5H9.875C10.175 0.5 10.4375 0.6125 10.6625 0.8375C10.8875 1.0625 11 1.325 11 1.625V3.5H14.375C14.675 3.5 14.9375 3.6125 15.1625 3.8375C15.3875 4.0625 15.5 4.325 15.5 4.625V13.625C15.5 13.925 15.3875 14.1875 15.1625 14.4125C14.9375 14.6375 14.675 14.75 14.375 14.75H1.625ZM1.625 13.625H14.375V4.625H1.625V13.625ZM6.125 3.5H9.875V1.625H6.125V3.5Z",
    fill: "#8A6CAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.e90c959253b5917f4af280ec53d90626.svg";
export { ForwardRef as ReactComponent };